/**
* @Description 文件功能说明：车辆组件
* @Author
* @Time 2021/6/4
**/
<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">实时报警</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<AlarmRealTable ref="alarmRealTable" />
    </div>
</template>

<script>
import AlarmRealTable from "@/components_pages/Alarm/AlarmRealTable";

export default {
    /*
     * 组件名
     */
    name: "AlarmReal",
    /**
     * 引用组件
     * */
    components: {
        AlarmRealTable,
    },
    /**
     * 数据定义
     * */
    data(){
        return {
            // mini max tree box
        }
    },
    /**
     * 方法定义
     */
    methods: {
        /**
         * @Des 关闭路由
         * @Auth
         * @Date
         */
        closeRouter () {
            // 跳转到 首页
            this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
        },// closeRouter
        
    },// methods
    /**
     * 初始化加载
     */
    mounted() {
    	
    },// mounted
}// export default

</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/system-manager/alarm/AlarmReal.vue